import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(['material-icons', `md-${_ctx.size}`, `rotate-${_ctx.rotate}`]),
    style: _normalizeStyle({ '--size': `${_ctx.size}px` })
  }, _toDisplayString(_ctx.name), 7))
}